import React from 'react';
import {
  ChildProps,
} from 'react-apollo';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import gql from 'graphql-tag';
import {
  CoreFeedbackSellerShopInfo,
  core_apimessages_Channel,
} from '../../schemas/rql';
import FeedbackShopLink from './feedback_shop_link';

interface IProps {
  listingId: string;
  channel?: core_apimessages_Channel;
}

const connect = withGraphql<IProps, CoreFeedbackSellerShopInfo.Query, CoreFeedbackSellerShopInfo.Variables>(
  gql`
    query Core_Feedback_SellerShopInfo(
      $listingId: String
      $channel: core_apimessages_Channel
    ){
      listing(input: { id: $listingId }) {
        _id
        shop(input: { channel: $channel }) {
          _id
          name
          slug
        }
      }
    }
  `,
  {
    options: (ownProps) => {
      return {
        ssr: true,
        variables: {
          listingId: ownProps.listingId,
          channel: ownProps.channel,
        },
      };
    },
  },
);

export class FeedbackSellerShopInfo extends React.Component<ChildProps<IProps, CoreFeedbackSellerShopInfo.Query>, null> {
  get loading() {
    return this.props.data.loading !== false;
  }

  get shop() {
    return this.props.data.listing.shop;
  }

  renderPlaceholder() {
    return (
      <div className="feedback-seller-shop-info feedback-seller-shop-info--placeholder"></div>
    );
  }

  render() {
    if (this.loading) {
      return this.renderPlaceholder();
    }

    return (
      <FeedbackShopLink
        shop={this.shop}
        channel={this.props.channel}
      />
    );
  }
}

export default connect(FeedbackSellerShopInfo);
